/** The Component which generate form based on input form field configs
 *  passed as json format
 *  Sample Usage of Form Generator
    <FormGenerator
        formFields=[]
        onSubmit={(generateFormData) => { console.log(generateFormData) }}
        onError={(errorMessage) => { console.log('Error if any') }
    />
 *
*/
/**
 * All Elements types currently supported by Form Generator
 * We might need to add if we are not supporting required form
 */
export var ElementType;
(function (ElementType) {
    ElementType["INPUT"] = "input";
    ElementType["SELECT"] = "select";
    ElementType["RADIO"] = "radio";
    ElementType["CHECKBOX"] = "checkbox";
    ElementType["TOGGLE"] = "toggle";
})(ElementType || (ElementType = {}));
//# sourceMappingURL=interface.js.map